import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function LanguageSwitcher({ isDarkTheme = false }) {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Get current language flag
  const getCurrentFlag = () => {
    switch(i18n.language) {
      case 'tr': return "🇹🇷";
      case 'az': return "🇦🇿";
      case 'ru': return "🇷🇺";
      case 'kk': return "🇰🇿";
      default: return "🇺🇸";
    }
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center justify-center w-10 h-10 rounded-xl shadow-sm transition-all duration-200 ${isDarkTheme
          ? 'bg-slate-900/80 hover:bg-slate-800/90 border border-slate-700/60 hover:border-slate-600/60'
          : 'bg-white/80 hover:bg-white/90 border border-stone-200/60 hover:border-stone-300/60'
        }`}
      >
        <span className="text-xl" role="img" aria-label="Language selector">
          {getCurrentFlag()}
        </span>
      </button>
      
      {isOpen && (
        <div className={`absolute right-0 mt-2 rounded-xl shadow-lg overflow-hidden backdrop-blur-md border min-w-[140px] z-50 ${isDarkTheme
          ? 'bg-slate-900/90 border-slate-700/60'
          : 'bg-white/90 border-stone-200/60'
        }`}>
          <button
            onClick={() => changeLanguage('tr')}
            className={`flex items-center w-full px-4 py-2 text-left transition-all duration-200 ${
              i18n.language === 'tr' 
                ? isDarkTheme 
                  ? 'bg-blue-900/50 text-blue-300' 
                  : 'bg-pink-50 text-pink-700'
                : isDarkTheme
                  ? 'text-gray-300 hover:bg-slate-800 hover:text-white'
                  : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl mr-2" role="img" aria-label="Turkish">🇹🇷</span>
            <span className="font-medium">Türkçe</span>
          </button>
          <button
            onClick={() => changeLanguage('az')}
            className={`flex items-center w-full px-4 py-2 text-left transition-all duration-200 ${
              i18n.language === 'az' 
                ? isDarkTheme 
                  ? 'bg-blue-900/50 text-blue-300' 
                  : 'bg-pink-50 text-pink-700'
                : isDarkTheme
                  ? 'text-gray-300 hover:bg-slate-800 hover:text-white'
                  : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl mr-2" role="img" aria-label="Azerbaijani">🇦🇿</span>
            <span className="font-medium">Azərbaycanca</span>
          </button>
          <button
            onClick={() => changeLanguage('ru')}
            className={`flex items-center w-full px-4 py-2 text-left transition-all duration-200 ${
              i18n.language === 'ru' 
                ? isDarkTheme 
                  ? 'bg-blue-900/50 text-blue-300' 
                  : 'bg-pink-50 text-pink-700'
                : isDarkTheme
                  ? 'text-gray-300 hover:bg-slate-800 hover:text-white'
                  : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl mr-2" role="img" aria-label="Russian">🇷🇺</span>
            <span className="font-medium">Русский</span>
          </button>
          <button
            onClick={() => changeLanguage('kk')}
            className={`flex items-center w-full px-4 py-2 text-left transition-all duration-200 ${
              i18n.language === 'kk' 
                ? isDarkTheme 
                  ? 'bg-blue-900/50 text-blue-300' 
                  : 'bg-pink-50 text-pink-700'
                : isDarkTheme
                  ? 'text-gray-300 hover:bg-slate-800 hover:text-white'
                  : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl mr-2" role="img" aria-label="Kazakh">🇰🇿</span>
            <span className="font-medium">Қазақша</span>
          </button>
          <button
            onClick={() => changeLanguage('en')}
            className={`flex items-center w-full px-4 py-2 text-left transition-all duration-200 ${
              i18n.language === 'en' 
                ? isDarkTheme 
                  ? 'bg-blue-900/50 text-blue-300' 
                  : 'bg-pink-50 text-pink-700'
                : isDarkTheme
                  ? 'text-gray-300 hover:bg-slate-800 hover:text-white'
                  : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl mr-2" role="img" aria-label="English">🇺🇸</span>
            <span className="font-medium">English</span>
          </button>
        </div>
      )}
    </div>
  );
}

export default LanguageSwitcher; 